export default {
  operation: '操作',
  total: '总计',
  fail: '失败',
  status: '状态',
  updateTime: '更新时间',
  refresh: '刷新',
  success: '成功',
  sendToAnt: '发送给Ant',
  history: '最近30天记录',
  refreshTime: '页面刷新时间: ',
  apiType: 'API类型',
  plant: '仓库',
  failCount: '失败次数',
  lastUpdateTime: '最后更新时间',
  errorCode: '错误代码',
  errorMessage: '错误信息',
  payloadStorePath: '负载存储路径',
  createTime: '创建时间',
  download: '下载',
  paramEmpty: 'Param不能为空',
  apiExist: 'Api调用日志不存在',
  taskExist: '任务不存在',
  notSupportWms: '不支持wms',
  serverError: 'gc-nfc-service内部服务器错误',
  APIDashboardLog: 'API看板日志'
}
